import { defineComponent, ref, computed, openBlock, createElementBlock, normalizeClass, createElementVNode, createVNode, unref, Fragment, renderList, createBlock, normalizeStyle, withCtx, toDisplayString, createCommentVNode, createTextVNode } from "vue";
import GenericLazyImageLoader from "../GenericLazyImageLoader/GenericLazyImageLoader2.mjs";
import { CdrButton, IconPlusLg, IconHeartStroke } from "@rei/cedar";
const _hoisted_1 = {
  class: "pdp-sr-only"
};
const _hoisted_2 = {
  class: "ugc-image__user"
};
const _hoisted_3 = {
  class: "ugc-image__handle"
};
const _hoisted_4 = {
  class: "ugc-image__likes"
};
const _hoisted_5 = {
  class: "ugc-image__date"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "UgcImage",
  props: {
    id: {
      default: ""
    },
    currentProductId: {
      default: ""
    },
    title: {},
    imageSrc: {
      default: ""
    },
    products: {
      default: Array
    },
    user: {
      default: () => ({
        userName: ""
      })
    },
    likes: {
      default: 0
    },
    postedDate: {},
    lazyOpts: {
      default: () => ({
        // IntersectionObserver options object
        observerOpts: {},
        // used in IntersectionObserver callback
        intersectionRatio: 0
      })
    },
    layout: {
      default: "horizontal"
    },
    isFocusable: {
      type: Boolean,
      default: false
    },
    expandableHotspot: {
      type: Boolean,
      default: false
    },
    imageClass: {
      default: null
    },
    imgHeight: {
      default: null
    },
    imgWidth: {
      default: null
    },
    zoomBackground: {
      type: Boolean,
      default: true
    }
  },
  emits: ["ugcImageClick", "metricsClick"],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const ugcImage = ref();
    const current = ref();
    const wrapper = {
      current
    };
    const props = __props;
    const emit = __emit;
    const currentProduct = computed(() => props.products.find((product) => product.metadata.productId === props.currentProductId));
    function handleHotspotClick(product, event) {
      var _a, _b;
      const el = wrapper.current ? (_b = (_a = wrapper.current.value) == null ? void 0 : _a[0]) == null ? void 0 : _b.$el : void 0;
      emit("ugcImageClick", {
        product,
        el
      });
    }
    function handleImageLoaded() {
      var _a, _b, _c;
      const isVisible = !!((_a = ugcImage.value) == null ? void 0 : _a.offsetParent) || !!((_b = ugcImage.value) == null ? void 0 : _b.offsetHeight) || !!((_c = ugcImage.value) == null ? void 0 : _c.offsetWidth);
      if (isVisible) emit("metricsClick", {
        linkName: "ugc_view"
      });
    }
    __expose({
      ugcImage
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        ref_key: "ugcImage",
        ref: ugcImage,
        class: normalizeClass(["ugc-image", _ctx.layout === "horizontal" ? "ugc-image--landscape" : null])
      }, [createElementVNode("div", {
        class: normalizeClass(["ugc-image__image-wrapper", _ctx.imageClass])
      }, [createVNode(unref(GenericLazyImageLoader), {
        id: _ctx.id,
        title: _ctx.title,
        "image-src": _ctx.imageSrc,
        alt: _ctx.title,
        lazy: true,
        "lazy-opts": _ctx.lazyOpts,
        height: _ctx.imgHeight,
        width: _ctx.imgWidth,
        class: "ugc-image__image",
        onImageLoaded: handleImageLoaded
      }, null, 8, ["id", "title", "image-src", "alt", "lazy-opts", "height", "width"]), _ctx.isFocusable ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass(["ugc-image__hotspots", {
          "ugc-image__hotspots--landscape": _ctx.layout === "horizontal"
        }])
      }, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.products, (hotspot, index) => {
        var _a, _b;
        return openBlock(), createBlock(unref(CdrButton), {
          ref_for: true,
          ref: hotspot.metadata.productId === _ctx.currentProductId ? wrapper.current : void 0,
          key: hotspot.id,
          "data-ui": `hotspot-${index}`,
          "aria-current": hotspot.metadata.productId === _ctx.currentProductId ? true : false,
          "icon-only": true,
          class: normalizeClass(["ugc-image__hotspot", {
            "ugc-image__hotspot--current": hotspot.metadata.productId === _ctx.currentProductId
          }, {
            "ugc-image__hotspot--expandable": _ctx.expandableHotspot
          }]),
          style: normalizeStyle({
            top: `${(((_a = hotspot.spatialTag) == null ? void 0 : _a.y) || 0.5) * 100}%`,
            left: `${(((_b = hotspot.spatialTag) == null ? void 0 : _b.x) || 0.5) * 100}%`
          }),
          onClick: ($event) => handleHotspotClick(hotspot)
        }, {
          icon: withCtx(() => [createVNode(unref(IconPlusLg), {
            class: "ugc-image__hotspot-icon",
            "inherit-color": ""
          })]),
          default: withCtx(() => [createElementVNode("span", _hoisted_1, "Open details for " + toDisplayString(hotspot.name), 1)]),
          _: 2
        }, 1032, ["data-ui", "aria-current", "class", "style", "onClick"]);
      }), 128)), createElementVNode("div", {
        class: normalizeClass(_ctx.zoomBackground ? "ugc-image__hotspot-background-clickable" : null),
        onClick: _cache[0] || (_cache[0] = ($event) => handleHotspotClick(currentProduct.value))
      }, null, 2)], 2)) : createCommentVNode("", true)], 2), createElementVNode("div", _hoisted_2, [createElementVNode("span", _hoisted_3, " @" + toDisplayString(_ctx.user.userName), 1), createElementVNode("span", _hoisted_4, [createVNode(unref(IconHeartStroke), {
        class: "ugc-image__heart"
      }), _cache[1] || (_cache[1] = createElementVNode("span", {
        class: "pdp-sr-only"
      }, "number of likes: ", -1)), createTextVNode(" " + toDisplayString(_ctx.likes ? _ctx.likes : 0), 1)])]), createElementVNode("div", _hoisted_5, toDisplayString(_ctx.postedDate), 1)], 2);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=UgcImage3.mjs.map
